import React from "react";

/**
 * @param {String} header - The header of the section
 * @param {String} content - The content of the section
 * @param {String} link - The link to the section
 */
function Reading(props) {
  return (
    <div className="reading" style={{ display: "grid", gridTemplateColumns: "150px 1fr", gap: "20px", marginBottom: "25px" }}>
      {/* Left column: download button */}
      <a href={props.link} target="_blank" rel="noopener noreferrer">
        <img
          src="./readings/download_pdf.png"
          alt="Download PDF"
          style={{ width: "100%", maxWidth: "100px", display: "block", margin: "0 auto" }}
        />
      </a>

      {/* Right column: content */}
      <div>
        <h2 className="sub-header">{props.header}</h2>
        <p className="section-text">{props.content}</p>
      </div>
    </div>
  );
}

export default Reading;
